import React from 'react';
import PropTypes from 'prop-types';
import { graphql, Link, useStaticQuery } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import { GoCheck } from 'react-icons/go';
import useIsDesktopSize from '../../utils/isDesktopHook';
import { ANNUAL_PRICE } from '../../config/constants';
import {cta,ctaPrimary,ctaRow,heading,checklist,bulletIcon,ctaBtnRow,ctaBtn,imgRiseOnHover,imgRight} from './cta.module.scss';

const CtaGeneral0 = ({primaryEventId, secondaryEventId}) => {
    const isDesktopSize = useIsDesktopSize();
    const { runPayrollScreenshot } = useStaticQuery(IMG_QUERY);

    return (
        <section className={`${cta} ${ctaPrimary}`}>
            <div className={`section-inner justify-center ${ctaRow}`}>
                <div>
                    <h2 className={`${heading}`}>
                        To calculate employer taxes use PaycheckCity Payroll
                    </h2>
                    <div>
                        <ul className={`${checklist}`}>
                            <li>
                                <GoCheck className={`${bulletIcon}`} />
                                Unlimited companies, employees, and payroll runs for only ${ANNUAL_PRICE} a year
                            </li>
                            <li>
                                <GoCheck className={`${bulletIcon}`} />
                                All 50 states including local taxes, and multi-state calculations
                            </li>
                            <li>
                                <GoCheck className={`${bulletIcon}`} />
                                Federal forms W-2, 940 and 941
                            </li>
                        </ul>
                    </div>
                    <div className={`${ctaBtnRow}`}>
                        <a
                            href="https://payroll.paycheckcity.com/login/"
                            className={`${ctaBtn} btn btn-secondary-light`}
                            id={primaryEventId}>
                            Try 14 days free
                        </a>
                        <Link
                            to="/"
                            className={`${ctaBtn} btn-text-white btn-text-lg`}
                            id={secondaryEventId}>
                            How does it work?
                        </Link>
                    </div>
                </div>
                <>
                    {isDesktopSize ? (
                        <Link to="/" className={`${imgRiseOnHover} ${imgRight}`} aria-label="Learn about PaycheckCity Payroll">
                            <GatsbyImage
                                image={runPayrollScreenshot.childImageSharp.gatsbyImageData}
                                objectFit={ 'contain' }
                                quality={100}
                                alt="PaycheckCity Payroll is the most affordable solution for small-business payroll."
                            />
                        </Link>
                    ) : (
                        ``
                    )}
                </>
            </div>
        </section>
    );
};

const IMG_QUERY = graphql`
    {
        runPayrollScreenshot: file(relativePath: { eq: "payroll/payroll-screenshot.png" }) {
            childImageSharp {
                gatsbyImageData(quality: 100, width: 1000)
            }
        }
    }
`;

CtaGeneral0.propTypes = {
    primaryEventId: PropTypes.string.isRequired,
    secondaryEventId: PropTypes.string.isRequired,
};

export default CtaGeneral0;
